// import React, { useEffect, Profiler, useState } from 'react'
// // import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
// import './Component-css/Downloadbutton.css?v=0.1'
// // let deferredPrompt;
// const Downloadbutton = () => {
//   const [supportsPWA, setSupportsPWA] = useState(false)
//   const [promptInstall, setPromptInstall] = useState(null)

//   useEffect(() => {
//     const handler = e => {
//       e.preventDefault()
//       console.log('we are being triggered :D')
//       setSupportsPWA(true)
//       setPromptInstall(e)
//     }
//     window.addEventListener('beforeinstallprompt', handler)

//     return () => window.removeEventListener('transitionend', handler)
//   }, [])

//   const onClick = evt => {
//     evt.preventDefault()
//     if (!promptInstall) {
    
//       return
//     }
//     promptInstall.prompt()
//   }
//   if (!supportsPWA) {
//     return null
//   }

//   return (
//     <div
//       className='my-stickey-footer'
//       style={{
//         position: 'fixed',
//         bottom: '57px',
//         width: '100%',
//         maxWidth: 480,
//         backgroundColor: 'transparent',
//         left: '0px'
//       }}
//     >
//       <div className='text-center' style={{ zoom: '1.2', padding: '10px 0px' }}>
//         <button
//           onClick={onClick}
//           className='btn btn-sm text-white download_btn_bottom bounce-div'
//           style={{ fontWeight: 500 }}
//         >
          
//           DOWNLOAD OUR APPS
          
//         </button>
//       </div>
//     </div>
//   )
// }

// export default Downloadbutton
import React, { useState, useEffect } from "react";

const Downloadbutton = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      console.log("PWA trigger detected :D");
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    
    window.addEventListener("beforeinstallprompt", handler);

    // Fixed cleanup function to properly remove the exact event listener
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!supportsPWA || !isVisible) {
    return null;
  }

  return (
    <>
      <style>
        {`
          .premium-pwa-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.75);
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 99999;
            animation: fadeIn 0.3s ease-out forwards;
            padding: 20px;
          }

          .premium-pwa-popup {
            background: #0f1015; /* Clean plane black/dark background */
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 12px;
            width: 100%;
            max-width: 400px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.8);
            position: relative;
            overflow: hidden;
            animation: scaleUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
          }

          .pwa-close-btn {
            position: absolute;
            top: 15px;
            right: 15px;
            background: rgba(255, 255, 255, 0.1);
            border: none;
            color: #8892b0;
            width: 30px;
            height: 30px;
            border-radius: 6px;
            font-size: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            transition: all 0.2s ease;
            z-index: 10;
          }

          .pwa-close-btn:hover {
            background: rgba(255, 50, 50, 0.2);
            color: #ff4d4d;
          }

          .pwa-header {
            display: flex;
            align-items: center;
            padding: 25px 20px 15px 20px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          }

          .pwa-app-logo {
         
            height: 55px;
            border-radius: 8px; /* Clean square styling, no circles */
            object-fit: cover;
            margin-right: 15px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
          }

          .pwa-header-text {
            display: flex;
            flex-direction: column;
            text-align: left;
          }

          .pwa-header-text h3 {
            color: #ffffff;
            margin: 0 0 5px 0;
            font-size: 20px;
            font-weight: bold;
            letter-spacing: 0.5px;
          }

          .pwa-header-text p {
            color: #8892b0;
            margin: 0;
            font-size: 13px;
          }

          .pwa-body {
            padding: 25px 20px;
            text-align: center;
          }

          /* Animated Gold Button */
          .premium-download-btn {
            background: linear-gradient(135deg, #f0c022 0%, #d4a71c 100%);
            color: #000000;
            border: none;
            width: 100%;
            padding: 16px;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 1px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 12px;
            cursor: pointer;
            box-shadow: 0 8px 20px rgba(240, 192, 34, 0.3);
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
            animation: pulseGlow 2s infinite;
          }

          .premium-download-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 25px rgba(240, 192, 34, 0.5);
          }

          .premium-download-btn img {
            width: 22px;
            height: 22px;
            
          }

          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          @keyframes scaleUp {
            from { transform: scale(0.9); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }

          @keyframes pulseGlow {
            0% { box-shadow: 0 0 0 0 rgba(240, 192, 34, 0.4); }
            70% { box-shadow: 0 0 0 12px rgba(240, 192, 34, 0); }
            100% { box-shadow: 0 0 0 0 rgba(240, 192, 34, 0); }
          }
        `}
      </style>

      <div className="premium-pwa-overlay" onClick={handleClose}>
        {/* e.stopPropagation() prevents clicks inside the popup from closing it */}
        <div className="premium-pwa-popup" onClick={(e) => e.stopPropagation()}>
          
          <button className="pwa-close-btn" onClick={handleClose} aria-label="Close popup">
            &times;
          </button>

          <div className="pwa-header">
            <img src="/addanew.png" alt="App Logo" className="pwa-app-logo" />
            <div className="pwa-header-text">
              <h3>Download App</h3>
              <p>Install for a smoother experience</p>
            </div>
          </div>

          <div className="pwa-body">
            <button onClick={onClick} className="premium-download-btn">
              DOWNLOAD NOW
              <img src="/images/downloadicon.gif" alt="Download" />
            </button>
          </div>

        </div>
      </div>
    </>
  );
};

export default Downloadbutton;